import React from 'react';
import { getIcon, getIconColor, icons } from '../utils/iconConfig';
import './Icon.css';

/**
 * Icon component - Renders Material Symbols Rounded icons
 * 
 * @param {string} name - Icon name (can be category.key or direct icon name)
 * @param {string} category - Category for icon lookup (optional if using direct icon name)
 * @param {string} color - Color type ('success', 'error', 'warning', 'info', 'primary', 'secondary', 'muted', 'brand', 'nav_active', 'nav_inactive')
 * @param {string} customColor - Custom color (overrides color prop)
 * @param {boolean} darkMode - Dark mode state (defaults to true)
 * @param {number} size - Icon size in pixels (defaults to 24)
 * {string} className - Additional CSS classes
 * @param {object} style - Additional inline styles
 */
function Icon({ 
  name, 
  category, 
  color = 'primary', 
  customColor, 
  darkMode = true, 
  size = 24,
  className = '',
  style = {},
  ...props 
}) {
  // Get icon name
  let iconName;
  if (category && name) {
    // Use category.key format
    iconName = getIcon(category, name);
  } else if (name && icons[name]) {
    // Use direct icon name from icons object
    iconName = icons[name];
  } else if (name) {
    // Use name directly (already a Material icon name)
    iconName = name;
  } else {
    // Fallback
    iconName = 'help';
  }

  // Get color
  const iconColor = customColor || getIconColor(color, darkMode);

  // Combine styles
  const iconStyle = {
    fontSize: `${size}px`,
    color: iconColor,
    ...style
  };

  return (
    <span 
      className={`material-symbols-rounded ${className}`}
      style={iconStyle}
      {...props}
    >
      {iconName}
    </span>
  );
}

export default Icon;
export { icons, getIcon, getIconColor };
